module.exports = __webpack_public_path__ + "static/media/tradar-full.3af12677.png";